import { each } from 'lodash';
import { DateTime, DurationUnit } from 'luxon';
import { pluralize } from 'helpers/string';

interface TimeAgoSegment {
  unit: DurationUnit;
  unitPlural: keyof DurationKeys;
  minimum: number;
}

// TODO This should be removed and TypeScript errors in `timeDifferenceInWords` fixed
interface DurationKeys {
  years?: number;
  months?: number;
  days?: number;
  hours?: number;
  minutes?: number;
}

const TIME_AGO_SEGMENTS: TimeAgoSegment[] = [
  {
    unit: 'year',
    unitPlural: 'years',
    minimum: 1,
  },
  {
    unit: 'month',
    unitPlural: 'months',
    minimum: 1,
  },
  {
    unit: 'day',
    unitPlural: 'days',
    minimum: 1,
  },
  {
    unit: 'hour',
    unitPlural: 'hours',
    minimum: 0.75,
  },
  {
    unit: 'minute',
    unitPlural: 'minutes',
    minimum: 1,
  },
];

export const dateTimeInWords = (dateTime: DateTime, now = DateTime.local()) => {
  if (now.hasSame(dateTime, 'day')) {
    return 'Today';
  } else if (now.minus({ days: 1 }).hasSame(dateTime, 'day')) {
    return 'Yesterday';
  } else {
    return dateTime.toLocal().toLocaleString(DateTime.DATE_FULL);
  }
};

export const getActivityFeedHeader = (time: number) => {
  const now = DateTime.local();
  const difference = now.diff(DateTime.fromMillis(time), 'hours');
  const differenceInHours = Math.ceil(difference.hours);

  if (differenceInHours <= 24) {
    return 'Recent';
  }
  return 'Activity Feed';
};

export const timeDifferenceInWords = (dateTime: DateTime, now = DateTime.local()) => {
  let timeDifference = 'a minute';

  each(TIME_AGO_SEGMENTS, ({ unit, unitPlural, minimum }: TimeAgoSegment) => {
    const diff = now.diff(dateTime, [unit]);
    const value = Math.abs(diff[unitPlural]);

    if (value >= minimum) {
      const rounded = Math.round(value);

      timeDifference = `${rounded} ${pluralize(rounded, unit)}`;
      return false;
    }
  });

  return timeDifference;
};

export const timeAgoInWords = (dateTime: DateTime, now = DateTime.local(), suffix = ' ago') =>
  `${timeDifferenceInWords(dateTime, now)}${suffix}`;
